/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.6.6",
    versionName: "0.3.0-nightly.2026.6.6",
    versionChannel: "nightly",
    buildDate: "2026-06-06T00:37:48.760Z",
    commitHash: "b409787b0e1658ee3b655f347621f841d2b3a29a",
};
